module.exports = __webpack_public_path__ + "media/components/global/photos-banner/img/hot_air_balloon-small-bf29095bfa54a30fa3e775dd72543b2f.jpg";